// extracted by mini-css-extract-plugin
module.exports = {"aboutHeader":"AboutHeader_aboutHeader__3S4cx","main":"AboutHeader_main__4pLkj","text":"AboutHeader_text__36pPl","imgDiv":"AboutHeader_imgDiv__19cgb","img":"AboutHeader_img__2f36E"};